import { Component } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from 'ttag';

import { FeedFilterTitle } from '@components/FeedFilterTitle';
import { HiddenFilterBlock } from '../../../utils';

// constants
const waitBeforeModalClose = 1500;

const priceFilterData = [
  {
    price_from: null,
    price_to: 100,
  },
  {
    price_from: 100,
    price_to: 300,
  },
  {
    price_from: 300,
    price_to: 500,
  },
  {
    price_from: 500,
    price_to: 1000,
  },
  {
    price_from: 1000,
    price_to: null,
  },
];

function getInitialPriceFilter({ price_from, price_to }) {
  const foundIndex = priceFilterData.findIndex((filter) => {
    return (filter.price_from === price_from) && (filter.price_to === price_to);
  });

  return foundIndex > -1 ? foundIndex + 1 : null;
}

export default class PriceFilter extends Component {
  emitChangeDebounced = debounce(this.emitChange, waitBeforeModalClose);

  constructor(props) {
    super(props);

    this.state = {
      isActive: true,
      price_from: this.props.from,
      price_to: this.props.to,
      id: getInitialPriceFilter({
        price_from: this.props.from,
        price_to: this.props.to,
      }),
    };
  }

  componentDidUpdate() {
    if ((this.state.price_from !== this.props.from) && (this.state.price_to !== this.props.to)) {
      this.setState({
        price_from: this.props.from,
        price_to: this.props.to,
        id: getInitialPriceFilter({
          price_from: this.props.from,
          price_to: this.props.to,
        }),
      });
    }
  }

  componentWillUnmount() {
    this.emitChangeDebounced.cancel();
  }

  handleToggle = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  handlePriceChanged = (id) => {
    const newId = this.state.id === id ? null : id;
    const priceFilter = newId ? priceFilterData[(newId || 0) - 1] : {};

    this.setState({ id: newId });

    this.props.eventStream.next({
      action: 'setCustomPriceFilter',
      ...priceFilter,
    });
  };


  handleCustomPriceSet = (e) => {
    e.preventDefault();
    const priceFrom = parseInt(this.priceFrom.value, 0) || null;
    const priceTo = parseInt(this.priceTo.value, 0) || null;
    // Use react's state to avoid UI glitch from using
    // debounce over Rx stream of keyup event
    this.setState({
      price_from: priceFrom,
      price_to: priceTo,
      id: null,
    });
    this.props.eventStream.next({
      action: 'setCustomPriceFilter',
      price_from: priceFrom,
      price_to: priceTo,
    });
    this.emitChangeDebounced(e.target.value);
  };

  emitChange() {
    if (this.state.isActive) {
      HiddenFilterBlock();
    }
  }

  renderCostRangeItems() {
    return this.props.filters.map(
      (filter) => {
        const isChecked = this.state.id === filter.id;

        return (
          <li className="b-simple-list__item" key={`cost-range-${filter.id}`}>
            <input
              id={`cost-range-${filter.id}`}
              name="cost"
              type="checkbox"
              className="b-form-check-input"
              checked={isChecked}
              onChange={() => this.handlePriceChanged(filter.id)}
            />
            <label
              htmlFor={`cost-range-${filter.id}`}
              className="b-form-checkbox"
            >
              {filter.name}
            </label>
          </li>
        );
      },
    );
  }

  render() {
    const cls = classNames({
      'b-filter__section': true,
      'b-filter__section_state_active': this.state.isActive,
    });

    return (
      (<div id="filter-price" className={cls}>
        <FeedFilterTitle
          title={t`Ціна`}
          hide={!this.state.isActive}
          onClick={this.handleToggle}
        />
        <div className="b-filter__content">
          <ul className="b-filter__list b-simple-list">
            {this.renderCostRangeItems()}
          </ul>
          <div className="b-filter__price-row">
            <div className="b-filter__row">
              <div className="b-filter__input">
                <input
                  className="b-form-input"
                  ref={(input) => { this.priceFrom = input; }}
                  name="costFrom"
                  type="text"
                  placeholder={t`Від`}
                  value={this.state.price_from || ''}
                  onChange={this.handleCustomPriceSet}
                />
              </div>
            </div>
            <div className="b-filter__row">
              <div className="b-filter__input">
                <input
                  placeholder={t`До`}
                  className="b-form-input"
                  ref={(input) => { this.priceTo = input; }}
                  name="costTo"
                  type="text"
                  value={this.state.price_to || ''}
                  onChange={this.handleCustomPriceSet}
                />
              </div>
            </div>
          </div>
        </div>
      </div>)
    );
  }
}

PriceFilter.propTypes = {
  filters: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  from: PropTypes.number,
  to: PropTypes.number,
};

PriceFilter.defaultProps = {
  from: null,
  to: null,
};
